module.exports = __webpack_public_path__ + "img/final_art.69334e54.svg";